<mat-card class="altair-card customer-satisfaction-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                {{data.name}}
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <apx-chart
            [series]="chartOptions.series!"
            [chart]="chartOptions.chart!"
            [labels]="chartOptions.labels!"
            [title]="chartOptions.title!"
            [fill]="chartOptions.fill!"
            [yaxis]="chartOptions.yaxis!"
            [tooltip]="chartOptions.tooltip!"
            [stroke]="chartOptions.stroke!"
            [colors]="chartOptions.colors!"
            [legend]="chartOptions.legend!"
            [plotOptions]="chartOptions.plotOptions!"
        ></apx-chart>
    </mat-card-content>
</mat-card>
